import React, { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';

import Button from 'components/core/Button';
import Card from 'components/core/Card';
import Text from 'components/core/Text';
import TextInput from 'components/core/TextInput';

import { useLogin } from 'api/auth';
import { setSession } from 'configs/requestConfig';

import { StyledField, StyledForm, StyledLabel, StyledScreen } from './LoginScreen.styles';

const LoginScreen = () => {
  const { login, isPending } = useLogin();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const canSubmit = email.trim() && password && !isPending;

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!canSubmit) {
      return;
    }
    setError('');
    try {
      const { accessToken, refreshToken } = await login({ email: email.trim(), password });
      setSession({ accessToken, refreshToken });
      navigate({ to: '/' });
    } catch {
      setError('Invalid email or password.');
    }
  };

  return (
    <StyledScreen>
      <Card>
        <Text variant="subtitle" as="h1">
          Sign in
        </Text>
        <Text variant="body" color="textMuted">
          Spotlight Studio — admin access
        </Text>

        <StyledForm onSubmit={submit}>
          <StyledField>
            <StyledLabel>Email</StyledLabel>
            <TextInput
              label="Email"
              type="email"
              value={email}
              placeholder="you@wamo.io"
              autoComplete="username"
              onChange={(event) => setEmail(event.target.value)}
            />
          </StyledField>
          <StyledField>
            <StyledLabel>Password</StyledLabel>
            <TextInput
              label="Password"
              type="password"
              value={password}
              placeholder="••••••••"
              autoComplete="current-password"
              onChange={(event) => setPassword(event.target.value)}
            />
          </StyledField>

          {error ? (
            <Text variant="caption" color="danger">
              {error}
            </Text>
          ) : null}

          <Button type="submit" variant="primary" disabled={!canSubmit}>
            {isPending ? 'Signing in…' : 'Sign in'}
          </Button>
        </StyledForm>
      </Card>
    </StyledScreen>
  );
};

export default LoginScreen;
